import { GALLERY_MAX_ITEMS } from "@ext/markdown/elements/gallery/model/gallery";
import { Fragment, type Node } from "prosemirror-model";
import type { EditorState, Transaction } from "prosemirror-state";

const hasSource = (item: Node) => Boolean(item.attrs.src || item.attrs.path || item.attrs.content);

const collectGalleries = (doc: Node) => {
	const galleries: { pos: number; node: Node }[] = [];
	doc.descendants((node, pos) => {
		if (node.type.name !== "gallery") return true;
		galleries.push({ pos, node });
		return false;
	});
	return galleries;
};

const normalizeGalleries = (state: EditorState): Transaction | null => {
	const tr = state.tr;

	for (const { pos, node } of collectGalleries(state.doc).reverse()) {
		const items: Node[] = [];
		node.forEach((item) => {
			if (hasSource(item)) items.push(item);
		});
		if (items.length === node.childCount && items.length <= GALLERY_MAX_ITEMS) continue;

		const end = pos + node.nodeSize;
		if (!items.length) {
			tr.delete(pos, end);
			continue;
		}
		tr.insert(end, Fragment.from(items.slice(GALLERY_MAX_ITEMS)));
		tr.replaceWith(pos, end, node.copy(Fragment.from(items.slice(0, GALLERY_MAX_ITEMS))));
	}

	return tr.docChanged ? tr : null;
};

export default normalizeGalleries;
